var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9999,
    cy: 11.9999,
    r: 9.6,
    fill: "#10364D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4485 10.4484C16.6671 10.2221 16.788 9.919 16.7853 9.60437C16.7826 9.28973 16.6564 8.98876 16.4339 8.76627C16.2114 8.54378 15.9104 8.41757 15.5958 8.41484C15.2811 8.41211 14.978 8.53306 14.7517 8.75165L10.8001 12.7032L9.2485 11.1516C9.02218 10.9331 8.71905 10.8121 8.40442 10.8148C8.08978 10.8176 7.78881 10.9438 7.56632 11.1663C7.34383 11.3888 7.21762 11.6897 7.21489 12.0044C7.21216 12.319 7.33311 12.6221 7.5517 12.8484L9.9517 15.2484C10.1767 15.4734 10.4819 15.5998 10.8001 15.5998C11.1183 15.5998 11.4235 15.4734 11.6485 15.2484L16.4485 10.4484Z",
    fill: "#47EBEB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheckCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_check_circle.d904cd77a54684ede80f27647688f87f.svg";